import { ICartRootState, ICartState } from '../types';

export const selectCartState = (state: ICartRootState): ICartState => state.cart;
